import { type User } from '../employeeAccount';

export const userToString = (user: User): string => {
  return `${user.firstName} ${user.lastName}`;
};
